module.exports = __webpack_public_path__ + "static/media/img-c6f946a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/iowa-logo.png
// module id = 5289
// module chunks = 39